import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appPreventDoubleClick]',
  standalone: true
})
export class PreventDoubleClickDirective implements OnInit, OnDestroy {
  @Input() throttleTime = 1000;
  @Output() throttledClick = new EventEmitter();

  private clicks = new Subject<Event>();
  private subscription: Subscription = new Subscription();

  ngOnInit() {
    this.subscription = this.clicks
      .pipe(throttleTime(this.throttleTime))
      .subscribe((event) => this.throttledClick.emit(event));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
